export default __webpack_public_path__ + "static/media/Inter-Bold.1c3dfbb0.woff";